import React, { useEffect, useState } from "react";
import { Crown, Lock, Sparkles } from "lucide-react";
import { ResultDigits } from "./ResultDigits";

const to12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`; };
const minsAgo = (iso) => (iso ? (Date.now() - new Date(iso).getTime()) / 60000 : 1e9);

/* Queen's Draw — system auto-draw at the exact minute, digits revealed one by one, then LOCKED forever (nobody can change it). */
export const QueenReveal = ({ game, ta }) => {
  const r = game.last_result;
  const fresh = r && minsAgo(r.created_at) < 20;
  const [shown, setShown] = useState(fresh ? 0 : 99);
  useEffect(() => {
    if (!fresh) { setShown(99); return; }
    setShown(0);
    const digits = String(r.winning_number || "").length;
    const timers = [];
    for (let i = 1; i <= digits; i++) timers.push(setTimeout(() => setShown(i), 700 * i));
    return () => timers.forEach(clearTimeout);
  }, [r?.id]); // eslint-disable-line
  const digits = String(r?.winning_number || "").split("");
  return (
    <div className="mt-3 rounded-2xl p-3 relative overflow-hidden" style={{ background: "linear-gradient(135deg,#3b0764 0%,#6d28d9 55%,#b45309 100%)" }} data-testid="queen-reveal">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(90% 60% at 100% 0%, rgba(255,255,255,.18), transparent 60%)" }} />
      <div className="relative flex items-center justify-between gap-1.5">
        <div className="min-w-0">
          <div className="text-[9px] uppercase tracking-[.2em] text-amber-200 flex items-center gap-1"><Crown className="w-3 h-3" />{ta ? "ராணியின் டிரா" : "Queen's Draw"} · {ta ? "ஆட்டோ" : "AUTO"}</div>
          <div className="text-white font-display font-black text-base leading-tight">{r ? (ta ? `${r.draw_date} · ${to12(r.draw_time || game.draw_time)} இல் டிரா ஆனது` : `Drawn ${r.draw_date} at ${to12(r.draw_time || game.draw_time)}`) : (ta ? `அடுத்த டிரா ${to12(game.draw_time)}` : `Next draw at ${to12(game.draw_time)}`)}</div>
          <div className="text-[10px] text-amber-100 flex items-center gap-1 mt-0.5" data-testid="queen-locked-note"><Lock className="w-3 h-3" />{ta ? "கணினி தானாக எடுக்கும் · எடுத்த நொடியே LOCK — யாரும் மாற்ற முடியாது" : "Drawn by the system at the exact minute · LOCKED instantly — nobody can change it"}</div>
        </div>
        {r && (
          <div className="flex items-start gap-0.5 shrink-0" data-testid="queen-digits">
            {digits.map((d, i) => (
              <div key={i} className="flex flex-col items-center">
                <span className={`w-8 h-8 rounded-full flex items-center justify-center font-mono font-black text-base border-2 border-amber-300 transition-all duration-500 ${i < shown ? "bg-amber-300 text-slate-900 scale-100" : "bg-white/10 text-transparent scale-90"}`} style={i < shown && fresh ? { animation: "rl-coin-flip .7s ease-out" } : undefined} data-testid={`queen-digit-${i}`}>{i < shown ? d : "?"}</span>
              </div>
            ))}
            {shown >= digits.length && fresh && <Sparkles className="w-4 h-4 text-amber-200 animate-pulse" />}
          </div>
        )}
      </div>
      {r && shown >= digits.length && <div className="relative mt-2 flex justify-end"><ResultDigits number={r.winning_number} size="w-6 h-6 text-[11px]" labels className="bg-white/90 rounded-xl px-2 py-1" testId="queen-result-digits" /></div>}
    </div>
  );
};
